import React, { DragEvent } from "react";
import { FiLink, FiMove } from "react-icons/fi";
import { LinkButton } from "../../../types";
import LinkButtonItem from "../../links/LinkButtonItem";

interface LinksButtonsListProps {
  buttons: LinkButton[];
  draggedIndex: number | null;
  onDragStart: (event: DragEvent<HTMLDivElement>, index: number) => void;
  onDragOver: (event: DragEvent<HTMLDivElement>) => void;
  onDrop: (event: DragEvent<HTMLDivElement>, index: number) => void;
  onDragEnd: () => void;
  onChangeButton: (button: LinkButton) => void;
  onRemoveButton: (id: string) => void;
}

export function LinksButtonsList({
  buttons,
  draggedIndex,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
  onChangeButton,
  onRemoveButton,
}: LinksButtonsListProps) {
  return (
    <div>
      <div className="mb-4 flex items-center justify-between">
        <h4 className="font-semibold text-black dark:text-white">
          Seus Links
        </h4>
        {buttons && buttons.length > 0 && (
          <span className="text-xs text-gray-500 dark:text-gray-400 italic">
            Arraste para reordenar
          </span>
        )}
      </div>

      <div className="space-y-4">
        {buttons && buttons.length > 0 ? (
          buttons.map((button: LinkButton, index: number) => (
            <div
              key={button.id}
              draggable
              onDragStart={(event) => onDragStart(event, index)}
              onDragOver={onDragOver}
              onDrop={(event) => onDrop(event, index)}
              onDragEnd={onDragEnd}
              className={`group relative cursor-move transition-all ${
                draggedIndex === index
                  ? "scale-105 opacity-50 shadow-xl"
                  : "hover:scale-[1.02]"
              }`}
            >
              <div className="absolute -left-10 top-1/2 -translate-y-1/2 opacity-0 transition-opacity group-hover:opacity-100">
                <div className="rounded-lg bg-gray-100 p-2 dark:bg-gray-800">
                  <FiMove size={18} className="text-gray-400" />
                </div>
              </div>

              <LinkButtonItem
                data={button}
                onSubmit={onChangeButton}
                onRemove={onRemoveButton}
              />
            </div>
          ))
        ) : (
          <div className="flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-stroke bg-gray-50 py-16 dark:border-strokedark dark:bg-gray-800/50">
            <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-purple-100 dark:bg-purple-900/30">
              <FiLink
                size={32}
                className="text-purple-600 dark:text-purple-400"
              />
            </div>
            <p className="text-center font-semibold text-gray-900 dark:text-white">
              Nenhum link cadastrado
            </p>
            <p className="mt-1 text-center text-sm text-gray-600 dark:text-gray-400">
              Clique no botão acima para adicionar seu primeiro link
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

